import { capitalizeFirstLetterOfEachWord } from './capitalizeFirstLetterOfEachWord';

/**
 * CV-1900: `nicotine` is the internal storage/key for the Quit Smoking vertical.
 * Patient-facing surfaces (dashboard consult cards, treatment thumbnails and the
 * consult payment screen) must read "Quit Smoking" for consistency and
 * compliance. Only the displayed label changes here — the stored category key
 * stays `nicotine`, so no data/logic is affected.
 *
 * Any category without an explicit override falls back to the existing
 * title-case behaviour, so every other vertical renders exactly as before.
 */
const HEALTH_CATEGORY_DISPLAY_NAMES = {
  nicotine: 'Quit Smoking',
  'medicinal cannabis': 'Alternative Therapy',
};

/**
 * @param {string} category - the internal health-category / form key (e.g. 'nicotine').
 * @returns {string} the patient-facing display name for that category.
 */
export const getHealthCategoryDisplayName = (category = '') => {
  const override = typeof category === 'string' ? HEALTH_CATEGORY_DISPLAY_NAMES[category.toLowerCase()] : undefined;

  return override ?? capitalizeFirstLetterOfEachWord(category);
};
